import { ApolloError, gql, useMutation, useQuery } from '@apollo/client'

import { trackEvent } from 'analytics'
import { useSites } from 'store'
import { useRoom } from '../../use-rooms'

const OPERATION_PIN_CODE = gql`
  query InstallCodeForOtrum($sf_id: String!) {
    pin: installCodeForOtrum(sf_id: $sf_id)
  }
`
const OPERATION_PSK = gql`
  query AvailablePsk($sf_id: String!, $device_uuid: String!) {
    psk: availablePsk(sf_id: $sf_id, device_uuid: $device_uuid)
  }
`
const OPERATION_SYNC = gql`
  mutation SyncTvsMacAddress($sf_id: String!) {
    status: syncTvsMacAddress(sf_id: $sf_id)
  }
`

export const useSync = (): [() => Promise<void>, { loading: boolean, error: ApolloError | undefined }] => {
  const [{selected}] = useSites()
  const [syncTvsMacAddress, { loading, error }] = useMutation(OPERATION_SYNC, {
    variables: {
      sf_id: selected[0].sf_id
    }
  });

  return [
    async () => {
      await syncTvsMacAddress();
      trackEvent('stream_cast_mac_synced');
    },
    { loading, error}
  ]
}

export const usePin = () => {
  const [{ selected }] = useSites()
  const { data, loading, error } = useQuery(OPERATION_PIN_CODE, {
    fetchPolicy: 'network-only',
    variables: {
      sf_id: selected[0].sf_id,
    }
  })

  return {
    pin: data?.pin,
    loading,
    error,
  }
}

const usePsk = ({device}) => {
  const [{ selected }] = useSites()
  const room = useRoom()
  const { data, loading, error } = useQuery(OPERATION_PSK, {
    fetchPolicy: 'network-only',
    variables: {
      sf_id: selected[0].sf_id,
      device_uuid: device.uuid
    },
    skip: !room?.is_iot_format
  })

  return {
    psk: room?.is_iot_format ? data?.psk : `W1f1rst!${device.serial}`,
    loading,
    error,
  }
}

export default usePsk